import { AllowListEntryType, AllowListRule, AllowListRuleType } from './allow-list-model';

export const entryTypesMapper = (apiData: any): AllowListEntryType[] => {
  return apiData;
};

export const ruleTypesMapper = (apiData: any): AllowListRuleType[] => {
  return apiData;
};

export const allowListRulesMapper = (apiData: any): AllowListRule[] => {
  return apiData;
};
